export class Room {

    public id: string = "0";
    public name: string;
    public location: string;
    
    constructor() {}
}